<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title">
          캠퍼스별
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            수수료관리 → 캠퍼스별
          </div>
        </h5>
        <div>
          <p
            style="
              font-size: 14px;
              line-height: 24px;
              margin-top: 10px;
              color: #246281;
            "
          >
            - 해당 데이터는
            <span style="font-weight: bold">전월 말일23:50분을 기준</span>으로
            분석된 데이터입니다.<br />
            - 데이터 집계이후
            <span style="font-weight: bold">변경또는 취소된 아이디의 경우</span>
            해당 데이터에 집계되지 않습니다.
          </p>
        </div>
        <query-grid :config="config" ref="qg">
          <template #items="props">
            <tr v-for="record in props.records" v-bind:key="record.id">
              <td scope="row" style="text-align: center">{{ record.id }}</td>
              <td style="padding: 15px 0px">{{ record.local.name }}</td>
              <!--학원-->
              <td>{{ record.name }}</td>
              <!--학원-->
              <td>{{ parseInt(record.sub_cnt || 0).toLocaleString() }}</td>
              <td>
                {{ parseInt(record.sub_total_margin || 0).toLocaleString() }}
              </td>
              <td>{{ record.agreement_type }}</td>
            </tr>
          </template>
        </query-grid>
      </div>
    </div>
  </div>
</template>

<style></style>

<script>
import Tree from "../components/Tree";
import axios from "axios";
import Business from "../components/Business";
import QueryGrid from "../components/QueryGrid";
import treeBtn from "../components/treeBtn";
// @ is an alias to /src

export default {
  name: "Home",
  components: {
    Tree,
    treeBtn,
    Business,
    QueryGrid,
  },
  mounted() {
  },
  methods: {},
  data() {
    return {
      records: [],
      loading: false,
      searchBiz: [],
      config: {
        name: "가맹점 수수료 정산",
        req_endpoint: "/financials/campus/statics",
        default_limit: 20,
        search_fields: [
          {
            id: "businesses",
            name: "대상 본부",
            type: "business", // business, date, datetime,
          },
          {
            id: "month",
            name: "기간",
            type: "month", // business, date, datetime,
          },
        ],
        columns: [
          {
            id: "id",
            sortable: true,
            name: "#",
            excel_print: (v) => {
              return v.id;
            },
          },
          {
            id: "local_name",
            sortable: true,
            name: "본부명",
            excel_print: (v) => {
              return v.local.name;
            },
          },
          {
            id: "name",
            sortable: true,
            name: "캠퍼스명",
            excel_print: (v) => {
              return v.name;
            },
          },
          {
            id: "sub_cnt",
            name: "아이디 개수",
            excel_print: (v) => {
              return v.sub_cnt;
            },
          },
          {
            id: "sub_total_margin",
            name: "수수료",
            excel_print: (v) => {
              return v.sub_total_margin;
            },
          },
          {
            id: "agreement_type",
            name: "계약 유형",
            excel_print: (v) => {
              return v.agreement_type;
            },
          },
        ],
        disable_init_search: true,
      },
    };
  },
};
</script>
